export function onReady(fn: () => void | Promise<void>): void {
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        void fn();
      },
      { once: true },
    );
  } else {
    void fn();
  }
}
